module.exports = __webpack_public_path__ + "static/media/animal-elephant.324a41de.png";